import { connect } from 'react-redux';
import License from './License';
import {
    getApplicationListBegin,
    changeLicenseFilters,
    applyFilters,
    exportLicenses,
    getLicenseTypesBegin,
    setLicenseColumnSort,
} from '../../store/actions/license.actions';
import { setError } from '../../store/actions/site.actions';
import {
    getApplicationList,
    getApplicationListLoading,
    getListFilters,
    getFilteredApplicationListLoading,
    getLicenseTypes,
    getLoadMore,
    getLicensesCount,
    getLicensesSort,
} from '../../store/selectors/license.selectors';
import { getLicenseTableColumns } from '../../store/selectors/site.selectors';
import { getPersonTypesBegin } from '../../store/actions/person.actions';

const mapStateToProps = (state: any) => {
    const applicationList = getApplicationList(state);
    const isLoading = getApplicationListLoading(state);
    const isFilteredLoading = getFilteredApplicationListLoading(state);
    const listFilters = getListFilters(state);
    const licenseTypes = getLicenseTypes(state);
    const loadMore = getLoadMore(state);
    const licensesCount = getLicensesCount(state);
    const tableColumns = getLicenseTableColumns(state);
    const licensesSort = getLicensesSort(state);
    return {
        applicationList,
        isLoading,
        listFilters,
        isFilteredLoading,
        listFiltersRefresher: JSON.stringify(listFilters),
        licenseTypes,
        loadMore,
        licensesCount,
        tableColumns,
        licensesSort,
    };
};

const mapDispatchToProps = {
    getApplicationList: getApplicationListBegin,
    changeLicenseFilters,
    applyFilters,
    exportLicenses,
    getLicenseTypes: getLicenseTypesBegin,
    setError,
    getPersonTypes: getPersonTypesBegin,
    setLicenseColumnSort,
};

export default connect(mapStateToProps, mapDispatchToProps)(License);
